import React from "react";
import { Calendar as CalendarIcon } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconCalendar({ className, size = 16 }: Props) {
  return <CalendarIcon className={className} width={size} height={size} />;
}


